<div class="grid--center max--height bg--navy">
  <div class="display-column-flex mb--md row--valign-center color--white">
      <img height="150px" width="200px" src="./logo/pp-logo-crying-min.svg" />
      <h3 class="align-center">Page not found - Page non trouvée</h3>
      <p class="mt--none align-center">The page you are looking for is invalid or no longer available <br><br>La page que vous recherchez est invalide ou n'est plus disponible</p>
  </div>
</div>
